// extracted by mini-css-extract-plugin
module.exports = {"iconRobot":"icon-robot_iconRobot__IvOCs"};